import { jobWorkActionTypes } from '@Actions/production/jobWorkActions';

const JobWorkReducers = (state = {
  kanbanJobWorks: {
    machine: {
      loading: false,
      bottomLoading: false,
    },
    work_center: {
      loading: false,
      bottomLoading: false,
    },
    operator: {
      loading: false,
      bottomLoading: false,
    },
  },
  masterProductionProcessKanban: {
    machine: {
      loading: false,
      bottomLoading: false,
    },
    work_center: {
      loading: false,
      bottomLoading: false,
    },
    finished_good: {
      loading: false,
      bottomLoading: false,
    },
  },
  subJobCardsKanban: {
    machine: {
      loading: false,
      bottomLoading: false,
    },
    work_center: {
      loading: false,
      bottomLoading: false,
    },
    finished_good: {
      loading: false,
      bottomLoading: false,
    },
    operator: {
      loading: false,
      bottomLoading: false,
    },
  }
}, action) => {
  switch (action.type) {
  case jobWorkActionTypes.JOB_WORKS.LOADING: {
    const { getJobWorksLoading } = action;
    return {
      ...state,
      getJobWorksLoading,
    };
  }
  case jobWorkActionTypes.JOB_WORKS.SUCCESS: {
    const { jobWorks } = action;
    return {
      ...state,
      jobWorks,
    };
  }
  case jobWorkActionTypes.JOB_WORK_BY_MO_ID.LOADING: {
    const { getJobWorkByMoIdLoading } = action;
    return {
      ...state,
      getJobWorkByMoIdLoading,
    };
  }
  case jobWorkActionTypes.JOB_WORK_BY_MO_ID.SUCCESS: {
    const { moJobWork } = action;
    return {
      ...state,
      moJobWork,
    };
  }
  case jobWorkActionTypes.UPDATE_JOB_WORK.LOADING: {
    const { updateJobWorkLoading } = action;
    return {
      ...state,
      updateJobWorkLoading,
    };
  }

  case jobWorkActionTypes.GET_JOB_OPERATORS.LOADING: {
    const { getJobOperatorsLoading } = action;
    return {
      ...state,
      getJobOperatorsLoading,
    };
  }

  case jobWorkActionTypes.GET_JOB_OPERATORS.SUCCESS: {
    const { jobOperators } = action;
    return {
      ...state,
      jobOperators,
    };
  }

  case jobWorkActionTypes.GET_JOB_WORK_KANBAN.LOADING: {
    const { getJobWorksKanbanLoading } = action;
    return {
      ...state,
      getJobWorksKanbanLoading,
    };
  }

  case jobWorkActionTypes.GET_JOB_WORK_KANBAN.SUCCESS: {
    const { groupBy, jobWorks } = action;
    const { kanbanJobWorks } = state;
    const kanbanJobWorksCopy = JSON.parse(JSON.stringify(kanbanJobWorks));
    const newJobWorks = {
      ...jobWorks,
      job_works: jobWorks?.job_works?.map((item) => ({
        ...item,
        page: 1,
        previousPage: 0,
        limit: 100,
      })),
    };
    kanbanJobWorksCopy[groupBy] = {
      ...kanbanJobWorksCopy[groupBy],
      ...newJobWorks,
    };
    return {
      ...state,
      kanbanJobWorks: kanbanJobWorksCopy,
    };
  }

  case jobWorkActionTypes.GET_JOB_WORK_KANBAN_PAGE.LOADING: {
    const { groupBy, getJobWorksKanbanPageLoading } = action;
    const { kanbanJobWorks } = state;
    const kanbanJobWorksCopy = JSON.parse(JSON.stringify(kanbanJobWorks));
    kanbanJobWorksCopy[groupBy].bottomLoading = getJobWorksKanbanPageLoading;
    return {
      ...state,
      kanbanJobWorks: kanbanJobWorksCopy,
    };
  }

  case jobWorkActionTypes.GET_JOB_WORK_KANBAN_PAGE.SUCCESS: {
    const {
      groupBy, jobWorks, previousPage, page, groupName, count,
    } = action;
    const { kanbanJobWorks } = state;
    const kanbanJobWorksCopy = JSON.parse(JSON.stringify(kanbanJobWorks));
    for (let i = 0; i < kanbanJobWorksCopy[groupBy]?.job_works?.length; i++) {
      if (kanbanJobWorksCopy[groupBy]?.job_works[i]?.group_name === groupName) {
        kanbanJobWorksCopy[groupBy].job_works[i].page = page;
        kanbanJobWorksCopy[groupBy].job_works[i].previousPage = previousPage;
        if (page == 1) {
          kanbanJobWorksCopy[groupBy].job_works[i].count = count;
          kanbanJobWorksCopy[groupBy].job_works[i].job_works = jobWorks;
        } else {
          kanbanJobWorksCopy[groupBy].job_works[i].job_works = [...kanbanJobWorksCopy[groupBy].job_works[i].job_works, ...jobWorks];
        }
      }
    }
    return {
      ...state,
      kanbanJobWorks: kanbanJobWorksCopy,
    };
  }

  case jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN: {
    const { getMasterProductionProcessKanbanLoading } = action;
    return {
      ...state,
      getMasterProductionProcessKanbanLoading,
    };
  }
  case jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN.SUCCESS: {
    const { groupBy, masterProductionProcess } = action;
    const { masterProductionProcessKanban } = state;
    const masterProductionProcessKanbanCopy = JSON.parse(JSON.stringify(masterProductionProcessKanban));
    const newMasterProductionProcessKanban = {
      filters: masterProductionProcess?.filters,
      master_production_processes: masterProductionProcess?.data?.map((item) => ({
        ...item,
        page: 1,
        previousPage: 0,
        limit: 10,
      })),
    };
    masterProductionProcessKanbanCopy[groupBy] = {
      ...masterProductionProcessKanbanCopy[groupBy],
      ...newMasterProductionProcessKanban,
    };
    return {
      ...state,
      masterProductionProcessKanban: masterProductionProcessKanbanCopy,
    };
  }
  case jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN.LOADING: {
    const { getMasterProductionProcessKanbanLoading } = action;
    return {
      ...state,
      getMasterProductionProcessKanbanLoading,
    };
  }

  case jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN_PAGE.LOADING: {
    const { groupBy, getMasterProductionProcessKanbanPageLoading } = action;
    const { masterProductionProcessKanban } = state;
    const masterProductionProcessKanbanCopy = JSON.parse(JSON.stringify(masterProductionProcessKanban));
    masterProductionProcessKanbanCopy[groupBy].bottomLoading = getMasterProductionProcessKanbanPageLoading;
    return {
      ...state,
      masterProductionProcessKanban: masterProductionProcessKanbanCopy,
    };
  }
  case jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_KANBAN_PAGE.SUCCESS: {
    const { groupBy, masterProductionProcess, previousPage, page, groupName, count } = action;
    const { masterProductionProcessKanban } = state;
    const masterProductionProcessKanbanCopy = JSON.parse(JSON.stringify(masterProductionProcessKanban));
    for (let i = 0; i < masterProductionProcessKanbanCopy[groupBy]?.master_production_processes?.length; i++) {
      if (masterProductionProcessKanbanCopy[groupBy]?.master_production_processes[i]?.group_name === groupName) {
        masterProductionProcessKanbanCopy[groupBy].master_production_processes[i].page = page;
        masterProductionProcessKanbanCopy[groupBy].master_production_processes[i].previousPage = previousPage;
        if (page == 1) {
          masterProductionProcessKanbanCopy[groupBy].master_production_processes[i].count = count;
          masterProductionProcessKanbanCopy[groupBy].master_production_processes[i].master_production_process = masterProductionProcess;
        } else {
          masterProductionProcessKanbanCopy[groupBy].master_production_processes[i].master_production_process = [...masterProductionProcessKanbanCopy[groupBy].master_production_processes[i].master_production_process, ...masterProductionProcess];
        }
      }
    }
    return {
      ...state,
      masterProductionProcessKanban: masterProductionProcessKanbanCopy,
    };
  }

  case jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN.LOADING: {
    const { getSubJobCardsKanbanLoading } = action;
    return {
      ...state,
      getSubJobCardsKanbanLoading,
    };
  }
  case jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN.SUCCESS: {
    const { groupBy, subJobCards } = action;
    const { subJobCardsKanban } = state;
    const subJobCardsKanbanCopy = JSON.parse(JSON.stringify(subJobCardsKanban));
    const newSubJobCards = {
      filters: subJobCards?.filters,
      sub_job_cards: subJobCards?.sub_job_works?.map((item) => ({
        ...item,
        page: 1,
        previousPage: 0,
        limit: 10,
      })),
    };
    subJobCardsKanbanCopy[groupBy] = {
      ...subJobCardsKanbanCopy[groupBy],
      ...newSubJobCards,
    };
    return {
      ...state,
      subJobCardsKanban: subJobCardsKanbanCopy,
    };
  }
  case jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN_PAGE.LOADING: {
    const { groupBy, getSubJobCardsKanbanPageLoading } = action;
    const { subJobCardsKanban } = state;
    const subJobCardsKanbanCopy = JSON.parse(JSON.stringify(subJobCardsKanban));
    subJobCardsKanbanCopy[groupBy].bottomLoading = getSubJobCardsKanbanPageLoading;
    return {
      ...state,
      subJobCardsKanban: subJobCardsKanbanCopy,
    };
  }
  case jobWorkActionTypes.GET_SUB_JOB_CARDS_KANBAN_PAGE.SUCCESS: {
    const { groupBy, subJobCards, previousPage, page, groupName, count } = action;
    const { subJobCardsKanban } = state;
    const subJobCardsKanbanCopy = JSON.parse(JSON.stringify(subJobCardsKanban));
    for (let i = 0; i < subJobCardsKanbanCopy[groupBy]?.sub_job_cards?.length; i++) {
      if (subJobCardsKanbanCopy[groupBy]?.sub_job_cards[i]?.group_name === groupName) {
        subJobCardsKanbanCopy[groupBy].sub_job_cards[i].page = page;
        subJobCardsKanbanCopy[groupBy].sub_job_cards[i].previousPage = previousPage;
        if (page == 1) {
          subJobCardsKanbanCopy[groupBy].sub_job_cards[i].count = count;
          subJobCardsKanbanCopy[groupBy].sub_job_cards[i].sub_job_work = subJobCards;
        } else {
          subJobCardsKanbanCopy[groupBy].sub_job_cards[i].sub_job_work = [...subJobCardsKanbanCopy[groupBy].sub_job_cards[i].sub_job_work, ...subJobCards];
        }
      }
    }
    return {
      ...state,
      subJobCardsKanban: subJobCardsKanbanCopy,
    };
  }
  case jobWorkActionTypes.JOB_WORK_BY_ID.LOADING: {
    const { getJobWorkByIdLoading } = action;
    return {
      ...state,
      getJobWorkByIdLoading,
    };
  }
  case jobWorkActionTypes.JOB_WORK_BY_ID.SUCCESS: {
    const { selectedJobWork } = action;
    return {
      ...state,
      selectedJobWork,
    };
  }
  case jobWorkActionTypes.PROCESS_JW_MATERIAL.LOADING: {
    const { processJwMaterialLoading } = action;
    return {
      ...state,
      processJwMaterialLoading,
    };
  }
  case jobWorkActionTypes.PROCESS_JW_MATERIAL_COMPLETE.LOADING: {
    const { processJwMaterialCompleteLoading } = action;
    return {
      ...state,
      processJwMaterialCompleteLoading,
    };
  }
  case jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_LIST.LOADING: {
    const { getMasterProductionProcessListLoading } = action;
    return {
      ...state,
      getMasterProductionProcessListLoading,
    };
  }
  case jobWorkActionTypes.GET_MASTER_PRODUCTION_PROCESS_LIST.SUCCESS: {
    const { masterProductionProcessList } = action;
    return {
      ...state,
      masterProductionProcessList,
    };
  }
  case jobWorkActionTypes.GET_SUB_JOB_CARDS_LIST.LOADING: {
    const { getSubJobCardsListLoading } = action;
    return {
      ...state,
      getSubJobCardsListLoading,
    };
  }
  case jobWorkActionTypes.GET_SUB_JOB_CARDS_LIST.SUCCESS: {
    const { subJobCards } = action;
    return {
      ...state,
      subJobCards,
    };
  }
  default: {
    return state;
  }
  }
};

export default JobWorkReducers;
